import { CustomerServiceTypeFeeType } from '../@types/customer_service_type_fee';
import axios from '../utils/axios';

export const fetchAll = async (): Promise<CustomerServiceTypeFeeType[]> => {
  const response = await axios.get<CustomerServiceTypeFeeType[]>('customer-service-type-fee');
  return response.data;
};
